export default {
  sessionComposerDetachingEnabled: true,
};
